'use server'

import type {ClientPerspective} from '@sanity/client'
import {perspectiveCookieName} from '@sanity/preview-url-secret/constants'
import {refresh} from 'next/cache'
import {cookies} from 'next/headers'

import {sanitizePerspective} from '#live/sanitizePerspective'

/**
 * @internal CAUTION: this is an internal action and does not follow semver. Using it directly is at your own risk.
 */
export async function perspectiveChangeAction(perspective: ClientPerspective): Promise<void> {
  const sanitizedPerspective = sanitizePerspective(perspective, 'drafts')
  if (
    !sanitizedPerspective ||
    (Array.isArray(sanitizedPerspective) && sanitizedPerspective.length === 0)
  ) {
    throw new Error(`Invalid perspective`, {cause: perspective})
  }

  const nextPerspective = Array.isArray(sanitizedPerspective)
    ? sanitizedPerspective.join(',')
    : sanitizedPerspective
  const jar = await cookies()
  if (
    nextPerspective === jar.get(perspectiveCookieName)?.value &&
    process.env.NODE_ENV !== 'production'
  ) {
    // oxlint-disable-next-line no-console
    console.debug('perspectiveChangeAction', 'Perspective is the same, skipping', nextPerspective)
    return
  }
  jar.set(perspectiveCookieName, nextPerspective, {
    httpOnly: true,
    path: '/',
    secure: true,
    sameSite: 'none',
  })

  refresh()
}
